import { register } from "@shopify/theme-sections";

register("accordion", {
  initAccordion() {
    const headings = document.querySelectorAll(".accordion__heading");
    const triggers = [];
    const accordionContents = document.querySelectorAll(".accordion__rte");
    const multiselect = 0; // use 1
    const copyOpenClass = "accordion__rte--open";

    headings.forEach((h, i) => {
      let btn = h.querySelector("div");
      triggers.push(btn);
      let target = h.nextElementSibling;
      btn.onclick = () => {
        let expanded = btn.getAttribute("aria-expanded") === "true";
        if (expanded) {
          closeItem(target, btn);
        } else {
          openItem(target, btn);
        }
      };
    });
    function closeAllExpandedItems() {
      const expandedTriggers = triggers.filter(
        (t) => t.getAttribute("aria-expanded") === "true"
      );
      const expandedCopy = Array.from(accordionContents).filter((c) =>
        c.classList.value.includes(copyOpenClass)
      );
      expandedTriggers.forEach((trigger) => {
        trigger.setAttribute("aria-expanded", false);
      });
      expandedCopy.forEach((copy) => {
        copy.classList.remove(copyOpenClass);
        copy.style.maxHeight = 0;
      });
    }
    function closeItem(target, btn) {
      if (multiselect == 1) {
        closeAllExpandedItems();
      } else {
        btn.setAttribute("aria-expanded", false);
        target.classList.remove(copyOpenClass);
        target.style.maxHeight = 0;
      }
    }
    function openItem(target, btn) {
      if (multiselect == 1) {
        closeAllExpandedItems();
      }
      btn.setAttribute("aria-expanded", true);
      target.classList.add(copyOpenClass);
      target.style.maxHeight = target.scrollHeight + "px";
    }
  },

  onLoad: function (e) {
    this.initAccordion();
  },
});
